import store from "../../../common/state/store";
import appNotificationStoreFactory from "../../../common/state/modules/appNotificationStoreFactory";
import flashStoreFactory from "~/state/modules/flashStoreFactory";
import timezoneStoreFactory from "~/state/modules/timezoneStoreFactory";

export default class StoreFactory {
  static registerModules(flash, timezone: string) {
    store.registerModule('appNotificationStore', appNotificationStoreFactory());
    store.registerModule('flashStore', flashStoreFactory(flash));
    store.registerModule('timezoneStore', timezoneStoreFactory(timezone));
  }
}
